/* Redux */
import Redux from './Redux'

/* Material */
import Button from '@mui/material/Button'
import useStyles from './ActiveFilters.styles'

/* Material-Icons */
import ClearIcon from '@mui/icons-material/Clear'

const ActiveFilters: React.FC = () => {
  const classes = useStyles()

  const {
    suche,
    clearSuche,

    filterBrands,
    activeBrands,
    unsetBrand,

    filterTree,
    activeFilters,
    unsetFilterOption,
  } = Redux()

  if (
    suche.length < 3
    && Object.values(activeFilters).length === 0
    && activeBrands.length === 0
  ) return null

  const removeableFiltersButtons: JSX.Element[] = []

  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  // Suche-Filter
  if (suche.length >= 3) {
    removeableFiltersButtons.push(
      <Button
        key='suche'
        size='small' color='secondary' variant='contained'
        className={classes.button}
        endIcon={<ClearIcon />}

        onClick={()=>clearSuche()}
      >
        {suche}
      </Button>
    )
  }

  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  // Hersteller-Filter
  for (const brand of activeBrands) {
    const bid = Number(brand)
    const filterBrand = filterBrands.find(b => b.id === bid)
    if (filterBrand) {
      removeableFiltersButtons.push(
        <Button
          key={bid}

          size='small' color='secondary' variant='contained'
          className={classes.button}
          endIcon={<ClearIcon />}

          onClick={()=>unsetBrand(bid)}
        >
          {filterBrand.title}
        </Button>
      )
    }
  }

  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  // Filter-Optionen aus dem FilerTree
  for (const filter in activeFilters) {

    const filterInfo = filterTree.find(f=>f.id === Number(filter))
    if (!filterInfo) continue

    const activeFilterOptions = activeFilters[filter]
    const activeFilterOptionsArray = typeof activeFilterOptions === 'number' 
      ? [activeFilterOptions] : activeFilterOptions

    for (const option of activeFilterOptionsArray) {
      const filterOptionInfo = filterInfo?.options.find(o=>o.id === option)
      if (!filterOptionInfo) continue
      
      removeableFiltersButtons.push(
        <Button 
          key={option}

          size='small' color='secondary' variant='contained'
          className={classes.button}
          endIcon={<ClearIcon />}

          onClick={()=>unsetFilterOption({
            filter: filterInfo.id,
            option,
            type: filterInfo.type,
          })}
        >
          {filterOptionInfo.title}
        </Button>
      )

    }
  }
  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

  return <div className={classes.activeFilters}>
    {removeableFiltersButtons}
  </div>
}

export default ActiveFilters